import {
  Container,
  ContainerRow,
  DesktopContainer,
  MobileContainer,
} from "../../../../components/Container";
import { cryptoType, gameType, optionType, useApp } from "../../../../contexts";
import { useEffect, useCallback, useState } from "react";
import { FilterRow, FilterRowItem,FilterRowSearchItem, TitleHistory } from "./styles";
import { FormButton, FormDatePicker, FormItem, FormSelect } from "../../../../components/Form";
import FormButton2 from "../../../../components/FormCustom2/Button";
import FormInput from "../../../../components/FormCustom2/Input";
import { Col, Form, Row, ConfigProvider } from "antd";
import ExcelJS from "exceljs";
import {
  CellRowImage,
  CellRowValue,
  EqualIcon2,
} from "../../../wallet-list/styles";
import {
  CellStatus,
  ContainerTable,
  paginationRender,
  PaginationView,
  TableView,
} from "../../../../components/Table";
import {
  formatCurrency,
  getCashflowListSZT,
  getCashflowListSGT,
  getCashflowList,
  roundNumber,
  statusConvert,
  typeConvertSZT,
  typeConvertNew,
  statusSZTConvert,
  getCashflowOption,
  typeConvertSGT,
} from "../../../../services/app";

import moment from "moment";
import Detail from "./detail";
import produce from "immer";
import {
  Alert,
  AlertBg,
  AlertContent,
  AlertText,
  ErrorIcon,
  SuccessIcon,
} from "../../../withdraw/styles";
import { Copy } from "../../../../components/Copy";
import { useParams, useSearchParams } from "react-router-dom";
import { FilterMbIcon } from "../../../../components/Icons/FilterMbIcon";
import { CopyIcon } from "../../../../components/Icons/CopyIcon";
import {
  SZT_SORT,
  Sort,
  StatusSort,
  TYPE_WALLET_DETAIL,
  statusFilterTransaction1,
  statusFilterTransaction2,
  typeBalanceOptions,
  typeTransactionOptions,
} from "../../../../constants";
import ModalFilter from "./ModalFilter";
import EmptyTable from "../../../../components/EmptyTable";
import EmptyTableMobile from "../../../../components/EmptyTableMobile";
import { useWindowSize } from "../../../../hook/useWindowSize";
import { dateFormat } from "../../../../utils/helper";
import TransactionItem2 from "./TransactionItem2";
import DetailSgt from "./detail-sgt";

export const getValueByTab = (tab, values) => {
  if (values.length === 2) {
    if (tab === "crypto" || tab === "option") {
      return values[0];
    }
    return values[1];
  } else if (values.length === 3) {
    if (tab === "crypto") {
      return values[0];
    }
    if (tab === "option") {
      return values[1];
    }
    return values[2];
  } else if (values.length === 4) {
    if (tab === "crypto") {
      return values[0];
    }
    if (tab === "option") {
      return values[1];
    }
    if (tab === "gameCurrency" || tab === "game" || tab === "sztConversion") {
      return values[2];
    }
    return values[3];
  }
};

export default function TransactionHistory(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    loading,
    convertToBTC,
    convertToLocalCurrency,
    setLoading,
    currencies,
    convertToCurrency,
    language,
    user,
  } = useApp();
  const [searchParams] = useSearchParams();
  let { type, code, transactionId } = {
    type: searchParams.get("type"),
    code: searchParams.get("code"),
    transactionId: searchParams.get("transactionId"),
    ...(useParams() || {}),
  };
  useEffect(()=>{
    moment.updateLocale("en", {
      weekdaysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((item) =>
        T(item)
      ),
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug","Sep", "Oct", "Nov", "Dec"].map(item => T(item))
    });
  }, [language])
  const [tab, setTab] = useState(
    getValueByTab(type, ["crypto", "option", "sztConversion", "gameCurrencySGT"])
  );
  const [alert, setAlert] = useState("");
  const [datePicker, setDatePicker] = useState(false);
  const [sortBTC, setSortBTC] = useState(StatusSort.none);
  const [sort, setSort] = useState(Sort.createdTime_desc);
  const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onCell = (record, rowIndex) => {
    return {
      onClick: (event) => {
        if (
          event.target.classList.contains("copy") ||
          event.target.tagName === "svg" ||
          event.target.tagName === "path"
        ) {
          return;
        }
        if (!record.transactionId || !record.transactionCode) return;

        setRow({
          ...record,
          code: code,
        });
      },
    };
  };

  const handleSelectRow = (item) => {
    if (!item.transactionCode) return;
    setRow({...item, code: code});
  }

  const initQuery = () => {
    return getValueByTab(tab, [
      {
        option: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === optionType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        crypto: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === cryptoType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        game: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        sgt: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
      },
      {
        option: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === optionType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        crypto: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === cryptoType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        game: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
        sgt: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          keyword: "",
          fromDate: null,
          toDate: null,
          types: null,
        },
      },
    ]);
  };
  const [query, setQuery] = useState(initQuery());
  const [querySubmit, setQuerySubmit] = useState(initQuery());
  const [convertValue, setConvertValue] = useState([]);
  const [row, setRow] = useState();
  const [form] = Form.useForm();

  const toggleModalFilter = () => {
    setIsOpenModalFilter((prev) => !prev);
  };

  const columns = type === TYPE_WALLET_DETAIL.OPTION ? [
    {
      title: T("Time"),
      dataIndex: "time",
      key: "time",
      align: "left",
      className: "flex-start table-head-start",
      onCell: onCell,
      sorter: () => handleTableSort('time'), 
      render: (val) => (
        <span style={{ color: "#000", fontSize: 16, fontWeight: 400 }}>
          {val}
        </span>
      ),
    },
    {
      title: T("Type"),
      dataIndex: "type",
      key: "type",
      onCell: onCell,
      render: (text, record, index) => {
        const val = text.split(" ").join("_");
        return (
          <div className="flex items-center gap-[6px]">
            <span className="text-[#000000] font-normal text-[16px] leading-[25px] capitalize">
              {T(text).replace('{currency_code}', code)}
            </span>
          </div>
        );
      },
    },
    {
      title: T("Avatar ID"),
      dataIndex: "amount",
      key: "record",
      align: "left",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <span
            className={`text-[16px]`}
          >
             {record.item_id}
          </span>
        );
      },
    },
    {
      title: T("Balance"),
      dataIndex: "amount",
      key: "amount",
      align: "left",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <span
            className={`text-[16px] ${
              text > 0 ? "text-[#29CC6A]" : "text-[#FC5555]"
            }`}
          >
            {formatCurrency(text)}
          </span>
        );
      },
    },
    {
      title: T("BTC Value"),
      dataIndex: "btc",
      align: "left",
      className: "btc-value flex-start",
      key: "btc",
      sorter: () => handleTableSort('amount'),
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <CellRowValue
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <div style={{ display: "inline-block" }}>
              <p className="text-[16px] font-normal">{formatCurrency(text)}</p>
              <span>
                <EqualIcon2 />
                <span
                  style={{
                    fontSize: 14,
                    color: "#818181",
                    fontWeight: 400,
                    marginLeft: 7,
                  }}
                >
                  {formatLocalCurrency(roundNumber(record.local, 2))}
                </span>
              </span>
            </div>
          </CellRowValue>
        );
      },
    },
    {
      title: T("Transaction ID"),
      dataIndex: "transaction_code",
      className: "transaction_code",
      key: "transaction_code",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          text ? <div className="w-[150px]">
            <Copy
              textStyle={{ fontWeight: 400, fontSize: 16 }}
              cutText={true}
              splitFont={5}
              numDot={3}
              text={text}
              icon={<CopyIcon />}
            />
          </div>: <></>
        );
      },
    },
  ] : [
    {
      title: T("Time"),
      dataIndex: "time",
      key: "time",
      align: "left",
      className: "flex-start table-head-start",
      onCell: onCell,
      sorter: () => handleTableSort('time'), 
      render: (val) => (
        <span style={{ color: "#000", fontSize: 16, fontWeight: 400 }}>
          {val}
        </span>
      ),
    },
    {
      title: T("Type"),
      dataIndex: "type",
      key: "type",
      onCell: onCell,
      render: (text, record, index) => {
        const val = text.split(" ").join("_");
        return (
          <div className="flex items-center gap-[6px]">
            <span className="text-[#000000] font-normal text-[16px] leading-[25px] capitalize">
              {T(text).replace('{currency_code}', code)}
            </span>
          </div>
        );
      },
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      align: "left",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <span
            className={`text-[16px] ${
              text > 0 ? "text-[#29CC6A]" : "text-[#FC5555]"
            }`}
          >
            {formatCurrency(text)}
          </span>
        );
      },
    },
    {
      title: T("BTC Value"),
      dataIndex: "btc",
      align: "left",
      className: "btc-value flex-start",
      key: "btc",
      sorter: () => handleTableSort('amount'),
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <CellRowValue
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <div style={{ display: "inline-block" }}>
              <p className="text-[16px] font-normal">{formatCurrency(text)}</p>
              <span>
                <EqualIcon2 />
                <span
                  style={{
                    fontSize: 14,
                    color: "#818181",
                    fontWeight: 400,
                    marginLeft: 7,
                  }}
                >
                  {formatLocalCurrency(roundNumber(record.local, 2))}
                </span>
              </span>
            </div>
          </CellRowValue>
        );
      },
    },
    {
      title: T("Transaction ID"),
      dataIndex: "transaction_code",
      className: "transaction_code",
      key: "transaction_code",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          text ? <div className="w-[150px]">
            <Copy
              textStyle={{ fontWeight: 400, fontSize: 16 }}
              cutText={true}
              splitFont={5}
              numDot={3}
              text={text}
              icon={<CopyIcon />}
            />
          </div>: <></>
        );
      },
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    if (field === "btc") {
      setSortBTC(order);
    }
  };
  const handleTableSort = (col) => {
    if (col == 'time') {
      if (!sort) {
        setSort(Sort.createdTime_desc);
        return;
      }
      if (sort && sort == Sort.createdTime_desc) {
        setSort(Sort.createdTime_asc)
      }else{
        setSort(Sort.createdTime_desc)
      }
    }else{
      if (!sort) {
        setSort(Sort.amount_desc);
        return;
      }
      if (sort && sort == Sort.amount_desc) {
        setSort(Sort.amount_asc);
      } else {
        setSort(Sort.amount_desc);
      }
    }
    setPage(1);
  }
  useEffect(() => {
    if (transactionId) {
      setRow({ transaction_id: transactionId, code: code });
    }
  }, [transactionId]);

  useEffect(() => {
    loadData().then();
  }, [page, tab, sort, querySubmit]);

  useEffect(() => {
    setPage(1)
  }, [querySubmit]);

  useEffect(() => {
    let timer;
    if (alert) {
      timer = setTimeout(() => setAlert(""), 2000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [alert]);

  const convertData = useCallback(() => {
    return rows.map((item) => {
      let status = statusConvert(item);
      let itemType = code === 'SZT' ? typeConvertSZT(item) : code === 'SGT' ? typeConvertSGT(item) :  typeConvertNew(item);
      return (code === "SZT" || code === "SGT")
        ? {
          ...item,
          type: itemType,
          status: status,
          time: moment(item.createTime).format("YYYY/MM/DD HH:mm:ss"),
          amount: item.amount,
          coin: "ETH",
          coinFrom: code,
          transaction_code: item.transactionCode,
          transaction_id: item.transactionId,
          btc: convertToBTC(Math.abs(item.amount), code , getCurrency()),
          local: convertToLocalCurrency(
            Math.abs(item.amount),
            code,
            getCurrency()
          ),
        }: {
            ...item,
            local: convertToLocalCurrency(
              Math.abs(item.amount),
              item.currency_code,
              getCurrency()
            ),
            id: item.id,
            transactionId: item.transaction_id,
            transactionCode: item.transaction_code,
            type: itemType,
            coin: item.dest_currency_code,
            coinFrom: item.from_currency_code,
            toAmount: convertToCurrency(
              item.amount,
              item.from_currency_code,
              item.dest_currency_code,
              getCurrency()
            ),
            amount: item.amount,
            btc: convertToBTC(
              Math.abs(item.amount),
              item.currency_code,
              getCurrency()
            ),
            status: status,
            time: moment(item.created_time).format("YYYY/MM/DD HH:mm:ss"),
          };
    });
  }, [
    convertToBTC,
    convertToCurrency,
    convertToLocalCurrency,
    getCurrency,
    rows,
    code
  ]);
  
  const loadData = async () => {
    const data = getValueByTab(tab, [
      querySubmit.crypto,
      querySubmit.option,
      querySubmit.game,
      querySubmit.sgt,
    ]);
    
    // const types = !data.types ? getTypesByTab(type, code) : data.types;
    const types = !data.types ? undefined : data.types;
    const fromDate = data.fromDate
      ? moment(data.fromDate).startOf("day").valueOf()
      : null;
    const toDate = data.toDate
      ? moment(data.toDate).endOf("day").valueOf()
      : null;
    let result = null;
    if (code === "SZT") {
      const sorts = SZT_SORT[sort] ? [SZT_SORT[sort]] : undefined;
      result = await getCashflowListSZT({
        page: page,
        size: 15,
        ...data,
        ...getValueByTab(tab, [{}, {}, {}]),
        fromDate,
        types,
        sorts: sorts,
        toDate,
      });
    } else if (code === "SGT") {
      const sorts = SZT_SORT[sort] ? [SZT_SORT[sort]] : undefined;
      result = await getCashflowListSGT({
        page: page,
        size: 15,
        ...data,
        ...getValueByTab(tab, [{}, {}, {}]),
        fromDate,
        types,
        sorts: sorts,
        toDate,
      });
    } else if (type === "option") {
        result = await getCashflowOption({
          page: page,
          size: 15,
          ...data,
          ...getValueByTab(tab, [{}, {}, {}]),
          fromDate,
          types,
          sort,
          toDate,
        });
    } else {
      result = await getCashflowList({
        page: page,
        size: 15,
        ...data,
        ...getValueByTab(tab, [{}, {}, {}]),
        fromDate,
        types,
        sort,
        toDate,
      });
    }
    if (result.status === 200) {
      const data = result?.data?.data?.cashflows?.rows || [];
      setTotal(result?.data?.data?.cashflows?.count || 0);
      setRows(data);
    }
    setLoading(false);
  };
  const loadDataExport = async () => {
    let exportPage = 1;
    const data = getValueByTab(tab, [
      querySubmit.crypto,
      querySubmit.option,
      querySubmit.game,
      querySubmit.sgt,
    ]);
    const types = !data.types ? undefined : data.types;
    const fromDate = data.fromDate
      ? moment(data.fromDate).startOf("day").valueOf()
      : null;
    const toDate = data.toDate
      ? moment(data.toDate).endOf("day").valueOf()
      : null;
    let dataExport = [];
    while (true) {
      let result = {};
      if (code === "SZT") {
        const sorts = SZT_SORT[sort] ? [SZT_SORT[sort]] : undefined;
        result = await getCashflowListSZT({
          page: exportPage,
          size: 500,
          ...data,
          ...getValueByTab(tab, [{}, {}, {}]),
          fromDate,
          types,
          sorts: sorts,
          toDate,
        });
      }else if (code === "SGT") {
        const sorts = SZT_SORT[sort] ? [SZT_SORT[sort]] : undefined;
        result = await getCashflowListSGT({
          page: exportPage,
          size: 500,
          ...data,
          ...getValueByTab(tab, [{}, {}, {}]),
          fromDate,
          types,
          sorts: sorts,
          toDate,
        });
      }else if (type === "option") {
        result = await getCashflowOption({
          page: page,
          size: 500,
          ...data,
          ...getValueByTab(tab, [{}, {}, {}]),
          fromDate,
          types,
          sort,
          toDate,
        });
      } else {
        result = await getCashflowList({
          page: exportPage,
          size: 500,
          ...data,
          ...getValueByTab(tab, [{}, {}, {}]),
          fromDate,
          types,
          sort,
          toDate,
        });
      }
      if (result.status === 200) {
        const data = result?.data?.data?.cashflows?.rows || [];
        dataExport = [...dataExport, ...data];
        exportPage +=1
        if (result?.data?.data?.cashflows?.rows.length < 500) break
      }
    }
    return dataExport;
  }
  const handleExport = async () => {
    try {
      if (loading) return ;
      setLoading(true);

      const cashflowData = await loadDataExport();

      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("Data");

      const columns = [
        { key: "user_id", header: T("User Id") },
        { key: "user_email", header: T("Email") },
        { key: "user_name", header: T("Display name") },
        { key: "transaction_code", header: T("Transaction ID") },
        { key: "wallet_address", header: T("From Address") },
        { key: "to_address", header: T("To Address") },
        { key: "amount", header: T("Amount") },
        { key: "local_value", header: T("Value") },
        { key: "fee_amount", header: T("Fee") },

      ];
      if (type === "option") {
        columns.push({ key: "avatar_id", header: T("Avatar ID") });
      }
      columns.push({ key: "type", header: T("Type") })
      columns.push({ key: "status", header: T("Status") })
      columns.push({ key: "time", header: T("Time") })
      worksheet.columns = columns;
      cashflowData.forEach((cashflow) => {
        let itemType = code === "SZT" ? typeConvertSZT(cashflow) : code === "SGT" ? typeConvertSGT(cashflow) : typeConvertNew(cashflow);
        let status = code === "SZT" || code === "SGT" ? statusSZTConvert(cashflow) : statusConvert(cashflow);
        const data = [
          user.id,
          user.email,
          user.name,
          (code === "SZT" || code === "SGT")
            ? (cashflow.transactionCode ? `"${cashflow.transactionCode}"` : '')
            : (cashflow.transaction_code ? `"${cashflow.transaction_code}"` : ''),
          cashflow.from_wallet_address,
          cashflow.dest_wallet_address,
          formatCurrency(cashflow.amount) +
            ((code === "SZT" || code === "SGT") ? code : cashflow.currency_code),
          formatLocalCurrency(
            (code === "SZT" || code === "SGT")
              ? convertToLocalCurrency(
                Math.abs(cashflow.amount),
                code,
                getCurrency()
              ) :
              convertToLocalCurrency(
                Math.abs(cashflow.amount),
                cashflow.currency_code,
                getCurrency()
              )
          ),
          formatCurrency(cashflow.fee_amount) +
          cashflow.fee_amount > 0 ? ((code === "SZT" || code == "SGT") ? code : cashflow.currency_code) : '',
        ];
        if (type === "option") {
          data.push(cashflow.item_id);
        }
        data.push(T(itemType).replace("{currency_code}", code));
        data.push(T(status));
        data.push(moment(
          code !== "SZT" && code !== "SGT" ? cashflow.created_time : cashflow.createTime
        ).format("YYYY/MM/DD HH:mm:ss"));
        worksheet.addRow(data);
      });

      const csvData = await workbook.csv.writeBuffer();
      const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvData], {
        type: "text/csv;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("charset", "utf-8");

      a.download = `cashflow-${dateFormat(new Date(), "yyyy-MM-ddHH:mm:ss")}.csv`;
      a.click();
      a.remove();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const onSearch = (reset = false) => {
    setLoading(true);
    if (reset) {
      setQuerySubmit(initQuery());
    } else {
      setQuerySubmit(JSON.parse(JSON.stringify(query)));
    }
    setIsOpenModalFilter(false);
  };

  const handleReset = () => {
    setQuery(initQuery());
    onSearch(true);
    setIsOpenModalFilter(false);
  };
  const handleChangeStart = (value) => {
    setQuery(
      produce((draft) => {
        draft[fieldTabName].fromDate = value;
      })
    )
  }
  const handleChangeEnd = (value) => {
    setQuery(
      produce((draft) => {
        draft[fieldTabName].toDate = value;
      })
    )
  }
  const handleChangeTime = (value) => {
    setQuery(
      produce((draft) => {
        if (value !== "customized") {
          draft[fieldTabName].date = value;
        }
        switch (value) {
          case "7days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(7, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "30days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(30, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "60days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(60, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "customized": {
            setDatePicker(true);
            break;
          }
          default: {
            draft[fieldTabName].fromDate = undefined;
            draft[fieldTabName].toDate = undefined;
          }
        }
      })
    );
  };

  const values = convertValue || [];
  const fieldTabName = getValueByTab(tab, [
    "crypto",
    "option",
    "game",
    "sgt",
  ]);
  const queryTabValue = getValueByTab(tab, [
    query?.crypto,
    query?.option,
    query?.game,
    query?.sgt,
  ]);

  const handleSort = (e) => {
    e.stopPropagation();
    if (!sortBTC) {
      setSortBTC(StatusSort.descend);
    }
    if (sortBTC === StatusSort.descend) {
      setSortBTC(StatusSort.ascend);
    }
    if (sortBTC === StatusSort.ascend) {
      setSortBTC(StatusSort.none);
    }
  };

  const renderItemMobile = () => {
    let isSorted = false;
    const valueClone = [...values];
    const valueSorted = valueClone?.sort((a, b) => {
      if (sortBTC === StatusSort.ascend) {
        isSorted = true;
        return b.btc - a.btc;
      }
      if (sortBTC === StatusSort.descend) {
        isSorted = true;
        return a.btc - b.btc;
      }
    });

    return (
      <Row gutter={[0, 20]}>
        {values?.length ? (
          (isSorted ? valueSorted : values)?.map((item) => (
            <Col key={item.id} span={24} onClick={() => handleSelectRow(item)}>
              <TransactionItem2
                handleSort={handleSort}
                sorted={sortBTC}
                version={3}
                item={item}
                code={code}
              />
            </Col>
          ))
        ) : (
          <div className="w-full flex justify-center pt-[10px]">
            <EmptyTableMobile T={T} />
          </div>
        )}
      </Row>
    );
  };

  useEffect(() => {
    setConvertValue(convertData);
  }, [convertData, rows]);

  const size = useWindowSize();
  return (
    <div>
      <div>
        <DesktopContainer>
          <TitleHistory>{T("Balance History")}</TitleHistory>
        </DesktopContainer>
        <MobileContainer>
          <div className="relative mt-[20px] flex items-center justify-between">
            <TitleHistory style={{ marginTop: 0, width: "unset" }}>
              {T("Balance History")}
            </TitleHistory>
            <div
              className="lg:hidden flex h-[35px] items-center justify-center rounded-3xl gap-[8px] bg-white w-[100px]"
              onClick={toggleModalFilter}
            >
              <FilterMbIcon />
              <span className="text-[14px] leading-[26px] text-[#000]">
                {T("Filter")}
              </span>
            </div>
          </div>
        </MobileContainer>
        <DesktopContainer>
          <Form ref={form} className="mt-[34px] lg:mt-[12px]">
            <FilterRow>
              <FilterRowItem>
                <FormItem label={T("Time")}>
                  <div className="flex gap-4">
                    <FormDatePicker
                      allowClear={false}
                      value={queryTabValue?.fromDate}
                      onChange={handleChangeStart}
                      placeholder={T("From")}
                      disabledDate={(current) => {
                        return moment(queryTabValue?.toDate) <= current;
                      }}
                    />
                    <FormDatePicker
                      allowClear={false}
                      value={queryTabValue?.toDate}
                      onChange={handleChangeEnd}
                      placeholder={T("To")}
                      disabledDate={(current) => {
                        return moment(queryTabValue?.fromDate) >= current;
                      }}
                    />
                  </div>
                </FormItem>
              </FilterRowItem>
              <FilterRowItem>
                <FormItem label={T("Type")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.types ?? ""}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].types =
                            value == "" ? value : [value];
                        })
                      )
                    }
                  >
                    {typeBalanceOptions(tab, code, user.country_code).map(
                      (type, index) => (
                        <FormSelect.Option
                          key={index.toString()}
                          value={type.value}
                        >
                          {T(type.label).replace("{currency_code}", code)}
                        </FormSelect.Option>
                      )
                    )}
                  </FormSelect>
                </FormItem>
              </FilterRowItem>
              <FilterRowItem>
                <FormItem label={T("Transaction ID")}>
                  <FormInput
                    value={queryTabValue?.keyword}
                    onChange={(value) =>
                      setQuery(
                        produce((draft) => {
                          draft[fieldTabName].keyword = value.target.value;
                        })
                      )
                    }
                    placeholder={T("Please enter Transaction ID")}
                  />
                </FormItem>
              </FilterRowItem>
            </FilterRow>
            <DesktopContainer>
              <FilterRow style={{ justifyContent: "flex-end" }}>
                <FilterRowSearchItem>
                  <ContainerRow style={{ justifyContent: "flex-end" }}>
                    <FormButton2
                      onClick={() => handleExport()}
                      className="black2"
                      height={52}
                      style={{
                        minWidth: 144,
                        width: language === "ja" ? "auto" : "100%",
                      }}
                    >
                      {T("Export")}
                    </FormButton2>
                    <ContainerRow style={{ width: 10 }} />
                    <FormButton2
                      style={{ width: "50%" }}
                      className="black2"
                      height={52}
                      width={144}
                      onClick={handleReset}
                    >
                      {T("Reset")}
                    </FormButton2>
                    <ContainerRow style={{ width: 10 }} />
                    <FormButton2
                      onClick={() => onSearch()}
                      className="black"
                      height={52}
                      style={{
                        minWidth: 144,
                        width: language === "ja" ? "auto" : "100%",
                      }}
                    >
                      {T("Search")}
                    </FormButton2>
                  </ContainerRow>
                </FilterRowSearchItem>
              </FilterRow>
            </DesktopContainer>
          </Form>
        </DesktopContainer>
        <>
          <DesktopContainer>
            <Container style={{ height: 24 }} />
            <ContainerTable>
              <TableView
                locale={{ emptyText: <EmptyTable T={T} /> }}
                scroll={{ x: true }}
                pagination={false}
                dataSource={values}
                columns={columns}
                onChange={handleTableChange}
              />
            </ContainerTable>
          </DesktopContainer>
          <MobileContainer>
            <Container style={{ height: 12 }} />
            {renderItemMobile()}
          </MobileContainer>
        </>
        {total / 15 > 1 ? (
          <PaginationView
            current={page}
            pageSize={15}
            onChange={(p, ps) => {
              setPage(p);
            }}
            total={total}
            itemRender={paginationRender}
          />
        ) : null}
      </div>

      {row ? (
        row.code == 'SGT' ? <DetailSgt 
          id={row.transaction_id}
          code={row.code}
          type={tab}
          onClose={(event) => {
            setRow(null);
            setAlert(event);
            loadData();
          }} />: 
        <Detail
          id={row.transaction_id}
          code={row.code}
          type={tab}
          onClose={(event) => {
            setRow(null);
            setAlert(event);
            loadData();
          }}
        />
        
      ) : null}

      {alert === "success" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <SuccessIcon />
            <AlertText style={{ color: "#4D67C1" }}>
              {T("Your withdrawal request has been canceled")}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}
      {alert === "error" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <ErrorIcon />
            <AlertText style={{ color: "#E01B1B" }}>
              {T(
                "Failed to cancel your withdrawal request. Please try again later or contact customer support."
              )}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}

      {/* {datePicker ? (
        <DatePickerView
          fromDate={query[fieldTabName].fromDate}
          toDate={query[fieldTabName].toDate}
          onCancel={() => {
            setDatePicker(false);
          }}
          onChange={(event) => {
            setQuery(
              produce((draft) => {
                draft[fieldTabName].date = "customized";
                draft[fieldTabName].fromDate = event.fromDate
                  .startOf("day")
                  .toDate()
                  .getTime();
                draft[fieldTabName].toDate = event.toDate
                  .endOf("day")
                  .toDate()
                  .getTime();
              })
            );
            setDatePicker(false);
          }}
        />
      ) : null} */}
      {isOpenModalFilter && (
        <ModalFilter
          setDatePicker={setDatePicker}
          handleChangeTime={handleChangeTime}
          queryTabValue={queryTabValue}
          fieldTabName={fieldTabName}
          onSearch={onSearch}
          onReset={handleReset}
          setQuery={setQuery}
          tab={tab}
          code={code}
          onClose={toggleModalFilter}
        />
      )}
    </div>
  );
}
